import { Typography } from "@mui/material";

export const Dashboard = () => {
  return <Typography>This is the dashboard.</Typography>;
};
